import axios from "axios";
export const insertModule = async (moduleData) => {
  try {
    const response = await axios.post("http://localhost:8080/webnet-hms/api/modules/", moduleData);
    window.alert("Module inserted successfully:", response.data);
    return response.data;
  } catch (error) {
    window.alert("Error inserting module:", error);
  }
};